module.exports = __webpack_public_path__ + "img/018-candy.0d04f787.png";